/*
 * -----------------------------------------------------------------------
 *  <copyright file="statistics-bar/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import cn from 'clsx';
import React from 'react';
import './styles.scss';
import { StatisticsBarProps } from '@components/core/statistics-bar/statistics-bar.interface';

const StatisticsBar = ({ data, className }: StatisticsBarProps) => (
    <div className={cn('statistics-bar', className)}>
        {data.map((item) => (
            <span key={item.name} className="statistics-bar__item">
                <span className="statistics-bar__title">{item.name}:</span>
                {item.value}
            </span>
        ))}
    </div>
);

export default StatisticsBar;
